import { render, staticRenderFns } from "./createOrderLimit.vue?vue&type=template&id=5021238d&scoped=true"
import script from "./createOrderLimit.vue?vue&type=script&lang=js"
export * from "./createOrderLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5021238d",
  null
  
)

export default component.exports